import React, { useEffect, useRef } from 'react';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

const TourGuide = ({ enabled, onExit }) => {
  const introRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    // Petit délai pour s'assurer que le DOM est chargé
    const timer = setTimeout(() => {
      // Nettoyer toute instance existante
      if (introRef.current) {
        try {
          introRef.current.exit(true);
        } catch (e) {
          console.log('Error exiting previous tour:', e);
        }
      }

      const intro = introJs();
      introRef.current = intro;
      
      intro.setOptions({
        steps: [
          {
            intro: '🎉 <strong>Bienvenue dans Pilote Noodly!</strong><br/><br/>Je vais vous faire découvrir les principales fonctionnalités de votre plateforme de gestion de franchise en vous montrant chaque section.',
          },
          {
            element: document.querySelector('aside nav') || document.querySelector('aside') || document.body,
            intro: '📱 <strong>Menu Navigation</strong><br/><br/>Accédez à tous vos outils depuis ce menu : Machines, Leads, Boutique, Analytics, et plus encore selon votre rôle.',
            position: 'right',
          },
          {
            element: document.querySelector('[data-testid="nav-dashboard"]') || document.querySelector('a[href="/"]') || document.body,
            intro: '🏠 <strong>Tableau de Bord</strong><br/><br/>Votre vue d\'ensemble : statistiques en temps réel, machines actives, chiffre d\'affaires et alertes.',
            position: 'right',
          },
          {
            element: document.querySelector('[data-testid="nav-machines"]') || document.querySelector('a[href="/machines"]') || document.body,
            intro: '🍜 <strong>Machines</strong><br/><br/>Gérez tous vos distributeurs : localisation GPS, stock en temps réel, maintenance et statistiques de ventes détaillées.',
            position: 'right',
          },
          {
            element: document.querySelector('[data-testid="nav-analytics"]') || document.querySelector('a[href="/analytics"]') || document.body,
            intro: '📊 <strong>Analytics Avancées</strong><br/><br/>Analysez vos performances avec des graphiques détaillés, filtres dynamiques et classements par produit.',
            position: 'right',
          },
          {
            element: document.querySelector('[data-testid="nav-leads"]') || document.querySelector('a[href="/leads"]') || document.body,
            intro: '💼 <strong>Opportunités</strong><br/><br/>Gérez votre pipeline commercial et les leads dispatchés automatiquement par zone géographique.',
            position: 'right',
          },
          {
            element: document.querySelector('a[href="/richard"]') || document.body,
            intro: '🤖 <strong>Richard IA</strong><br/><br/>Votre assistant intelligent pour vous aider dans la gestion quotidienne (disponible pour licenciés et gestionnaires).',
            position: 'right',
          },
          {
            element: document.querySelector('[data-testid="nav-annuaire"]') || document.querySelector('a[href="/annuaire"]') || document.body,
            intro: '📇 <strong>Annuaire</strong><br/><br/>Carte interactive de tous vos contacts : licenciés, gestionnaires et leur localisation.',
            position: 'right',
          },
          {
            element: document.querySelector('[data-testid="restart-tour-button"]') || document.querySelector('button[data-testid="restart-tour-button"]') || document.body,
            intro: '✅ <strong>C\'est tout!</strong><br/><br/>Vous pouvez relancer cette visite à tout moment en cliquant sur "Aide & Visite guidée" dans le menu.<br/><br/>Bonne utilisation de Pilote Noodly! 🚀',
            position: 'left',
          },
        ],
        nextLabel: 'Suivant →',
        prevLabel: '← Précédent',
        doneLabel: 'Terminer ✓',
        skipLabel: 'Passer',
        showProgress: true,
        showBullets: true,
        exitOnOverlayClick: false,
        exitOnEsc: true,
        disableInteraction: true,
        scrollToElement: true,
        scrollPadding: 30,
        tooltipClass: 'noodly-tour-tooltip',
      });

      intro.oncomplete(() => {
        introRef.current = null;
        onExit();
      });

      intro.onexit(() => {
        introRef.current = null;
        onExit();
      });

      // Lancer la visite
      try {
        intro.start();
      } catch (error) {
        console.error('Error starting tour:', error);
        onExit();
      }
    }, 500);

    return () => {
      clearTimeout(timer);
      if (introRef.current) {
        try {
          introRef.current.exit(true);
        } catch (e) {}
        introRef.current = null;
      }
    };
  }, [enabled, onExit]);

  return null;
};

export default TourGuide;
